export const stringToSlug = (string: string, delimiter: string): string => {
  return string.replace(/\W+/g, delimiter).toLowerCase();
};
